import { useLayoutEffect, useState } from 'react';
import { WIDE_BREAKPOINT } from './constants';

// Width of the tab's own container (the drawer takes 240 px, so the window width is the wrong
// thing to switch layouts on). Falls back to a media query when ResizeObserver is missing.
export default function useContentWidth(ref) {
  const [width, setWidth] = useState(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => setWidth(el.getBoundingClientRect().width);
    measure();
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => measure());
      ro.observe(el);
      return () => ro.disconnect();
    }
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [ref]);

  return width;
}

export const isWideWidth = (width) => width === null || width >= WIDE_BREAKPOINT;
